// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__1AFtL","wrapper":"Navbar_wrapper__3ckT8","navigation":"Navbar_navigation__32CLI"};